import React, { Component } from 'react';
import Editor from '@monaco-editor/react';
import { RootState } from '../../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../../../../RoleHelper';
import { ActionState } from '../../../../../redux/reducers/ActionReducer';
import { changeAction, changeActionIsUpdate, clearAction } from '../../../../../redux/actions/ActionActions';
import { enterComponent, leaveComponent } from '../../../../../redux/actions/ComponentActions';
import { ApiActionJsonModel } from '../../../../../domain/collection/rule/action/ActionDomains';
import ComponentName from '../../../../../constant/ComponentName';

class ApiBodyComponent extends Component<Props> {
  public render() {
    const {
      action: { action },
    } = this.props;
    return (
      <div className={'w-full h-full flex relative mt-4'}>
        <Editor
          options={{ readOnly: !RoleHelper.canEdit('Action') }}
          language={'java'}
          value={(action as ApiActionJsonModel).body}
          onChange={(e: string | undefined) => this.onChangeEditorValue(e)}
          data-testid={`${ComponentName.ACTION}_api_body`}
        />
      </div>
    );
  }

  private onChangeEditorValue(value: string | undefined) {
    const {
      action: { action },
      changeAction,
    } = this.props;
    if (!RoleHelper.canEdit('Action')) return;
    (action as ApiActionJsonModel).body = value || '';
    changeAction(action);
  }
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  action: state.action as ActionState,
  isUpdate: state.action.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = {
  changeActionIsUpdate,
  changeAction,
  clearAction,
  enterComponent,
  leaveComponent,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiBodyComponent);
